import { Button } from "@novaescola/eva-react-v2"
import Cookies from "js-cookie"
import React, { useMemo, useState } from "react"
import PhoneModal from "./PhoneModal"

export default function ButtonsActionSection({
  section,
  buttonEnabledText,
  buttonLink,
  addRegistrationBlockingButton,
  pageTitle,
  user,
  isSecondButton = false,
}) {
  const {
    btnPrimaryBackground,
    btnPrimaryColorText,
    btnSecondaryBackground,
    btnSecondaryColorText,
    haveSecondButton,
    secondButtonEnabledText,
    secondButtonLink,
    sendPdfWhatsappSecondButton,
    sendPdfWhatsappPrimaryButton,
    secondAddRegistrationBlockingButton
  } = section.body || {}
  const [showModal, setShowModal] = useState(false)
  const [linkRedirect, setLinkRedirect] = useState("")
  const [name, setName] = useState("")

  const isLpFimDeAnoLetivo =
    section.body?.title.trim() === "Observe e registre o desenvolvimento das crianças" ||
    section.body?.title.trim() === "Avalie as competências socioemocionais" ||
    section.body?.title.trim() === "Faça a autoavaliação"

  function isLpMapfre() {
    return section.body?.title.trim() === "Da vida real para as telas"
  }

  function isUserDataComplete() {
    if (!user) return false
    const { ocupacao, etapas, disciplinas, enderecos } = user
    const dtUltimaModificacao = new Date(user.dtUltimaModificacao)
    const lastYear = new Date()
    lastYear.setMonth(lastYear.getMonth() - 12)
    return (
      !!user.telefone1 &&
      !!ocupacao &&
      etapas?.length > 0 &&
      disciplinas?.length > 0 &&
      dtUltimaModificacao > lastYear &&
      enderecos?.length > 0 &&
      !!enderecos[0].cidade &&
      !!enderecos[0].estado
    )
  }

  function sendEvent(label = "") {
    window.dataLayer = window.dataLayer || []
    window.dataLayer.push({
      event: "cta_click",
      label: isLpFimDeAnoLetivo
        ? `SITE: Click - matrícula - LP fim de ano - ${section.body?.title} - botão BAIXAR PDF - ${label}`
        : `SITE: Click - ${pageTitle} - bloco destaque ${section.body?.title} - botão ${
            isSecondButton ? 2 : 1
          } - ${label}`,
    })
  }

  async function setRegistrationCookies() {
    const expires = new Date(Date.now() + 60 * 60 * 1000)
    const cookiesOptions = { expires, path: "/" }

    Cookies.set("ane_complemento_cadastro_redirect_url", buttonLink, cookiesOptions)
    Cookies.set(
      "ane_complemento_cadastro_event",
      JSON.stringify({
        category: "LP",
        label: `${section.body?.title} - botão BAIXAR PDF`,
        complement: pageTitle,
      }),
      cookiesOptions
    )
  }

  async function handleClick(validation) {
    sendEvent()
    if (!validation) {
      sendEvent("clique no botão com usuário deslogado")
      return
    }
    if (!user) {
      await setRegistrationCookies()
      sendEvent("deslogado fez login ou criou conta")
      return
    }
    if (isUserDataComplete()) {
      sendEvent("logado com dados completos clicou botão download")
    } else {
      await setRegistrationCookies()
    }
  }

  const buttonHref = useMemo(() => {
    if (addRegistrationBlockingButton === "true") {
      if (!user) return "https://account.novaescola.org.br/auth/signin"
      if (!isUserDataComplete()) return "/matricula"
    }
    return buttonLink
  }, [addRegistrationBlockingButton, user, buttonLink, section])

  const secondButtonHref = useMemo(() => {
    if (secondAddRegistrationBlockingButton === "true") {
      if (!user) return "https://account.novaescola.org.br/auth/signin"
      if (!isUserDataComplete()) return "/matricula"
    }
    return secondButtonLink
  }, [secondAddRegistrationBlockingButton, user, secondButtonLink, section])

  return (
    <>
      <div className="d-flex align-buttom" style={{ gap: "10px" }}>
        <Button
          variant="primary"
          size="large"
          asChild
          style={{
          ...(btnPrimaryBackground && {
            backgroundColor: btnPrimaryBackground,
            border: "none"
          }),
          ...(btnPrimaryColorText && { color: btnPrimaryColorText }),
            cursor: "pointer",
          }}
          onClick={async (e) => {
            await handleClick(addRegistrationBlockingButton)
            if (sendPdfWhatsappPrimaryButton) {
              e.preventDefault()
              setLinkRedirect(section.body.buttonLink)
              setName(section.body?.title)
              setShowModal(true)
              return
            }
          }}
        >
          <a
            target="_self"
            rel="noreferrer"
            type="button"
            className="eva-text-center"
            id={isLpMapfre() ? "jogarComoProfessor" : section.body?.sectionId}
            href={sendPdfWhatsappPrimaryButton ? undefined : buttonHref}
          >
            {buttonEnabledText}
          </a>
        </Button>

        {haveSecondButton &&
          (!section.body?.secondHideLinkButton ? (
            <Button
              variant="primary"
              size="large"
              asChild
              style={{
                ...(btnSecondaryBackground && {
                  backgroundColor: btnSecondaryBackground,
                  border: "none"
                }),
                ...(btnSecondaryColorText && { color: btnSecondaryColorText }),
                cursor: "pointer",
              }}
              onClick={async (e) => {
                await handleClick(secondAddRegistrationBlockingButton)
                if (sendPdfWhatsappSecondButton) {
                  e.preventDefault()
                  setLinkRedirect(section.body?.secondButtonLink)
                  setName(section.body?.title)
                  setShowModal(true)
                  return
                }
              }}
            >
              <a
                target="_self"
                rel="noreferrer"
                type="button"
                className="eva-text-center"
                href={sendPdfWhatsappSecondButton ? undefined : secondButtonHref}
                style={{
                  ...(btnSecondaryColorText && { color: btnSecondaryColorText }),
                }}
              >
                {secondButtonEnabledText}
              </a>
            </Button>
          ) : (
            <Button
              disabled
              variant="primary"
              size="large"
              aria-disabled="true"
              style={{
                ...(btnSecondaryColorText && { color: btnSecondaryColorText }),
                ...(btnSecondaryBackground && {
                  backgroundColor: btnSecondaryBackground,
                  border: "none"
                }),
              }}
            >
              {section.body?.secondButtonDisabledText}
            </Button>
          ))}
      </div>

      {showModal && (
        <PhoneModal
          user={user}
          linkRedirect={linkRedirect}
          onClose={() => setShowModal(false)}
          name={name || section.body?.title}
        />
      )}
    </>
  )
}
